// extracted by mini-css-extract-plugin
export default {"wrapper":"StartText_wrapper__fYiqi","text":"StartText_text__4pFMi"};